import { Navbar } from '../navbar';

// Run this function after page loaded
document.addEventListener("DOMContentLoaded", async function() {
  const navbar = new Navbar();
  navbar.setupNavbar();
});
